export const SET_SHARABLE_USERS = 'SET_SHARABLE_USERS';
export const SET_SHARABLE_TEAMS = 'SET_SHARABLE_TEAMS';
export const SET_SELECTED_USERS = 'SET_SELECTED_USERS';
export const SET_ACTIVE_TEAM = 'SET_ACTIVE_TEAM';
export const ADD_TEAM_TO_SHARED = 'ADD_TEAM_TO_SHARED';
export const ADD_USER_TO_SHARED = 'ADD_USER_TO_SHARED';



// WEBPACK FOOTER //
// ./src/views/Section_SharedTo/flow/actionTypes.js